import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { ValidatorsService } from '../../../../services/validators.service';
import { insurances } from '../../../../models/insurance/insurance-data.store';
import { brokers } from '../../../../models/broker/broker-data.store';
import { InvisibleReCaptchaComponent } from "ngx-captcha";
import { UserDataService } from "../../../../services/user-data.service";
import { AppState } from "../../../../app.reducer";
import { Store } from "@ngrx/store";
import { UserDataModel } from "../../../../store/user-data.model";
import { SetUserDataAction } from "../../../../store/user-data.actions";

declare var hljs: any;

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit, AfterViewInit {

  public insurances = insurances;
  public brokers = brokers;
  public currentStep = 1;
  public data: any;
  public newCompany: boolean = false;
  public userDataForm: any;
  public userData: any = {};
  public specSheetBase64File: any;
  public driverIdentificationBase64File: any;
  public licenseBase64File: any;
  public specSheetFileName = '';
  public driverIdentificationFileName = '';
  public licenseFileName = '';
  public showSpecSheetPreview = false;
  public showDriverIdentificationPreview = false;
  public showLicensePreview = false;
  public readonly siteKey = '6LcnfDcnAAAAABZus3WBtE7eewvZbZH6ZKriQ90F';
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;
  public badge: 'bottomright' | 'bottomleft' | 'inline' = 'inline';
  // @ts-ignore
  public type: 'image' | 'audio';
  public theme: 'light' | 'dark' = 'light';
  // @ts-ignore
  @ViewChild('captchaElem', { static: false }) captchaElem: InvisibleReCaptchaComponent;
  // @ts-ignore
  @ViewChild('langInput', { static: false }) langInput: ElementRef;

  constructor(private formBuilder: FormBuilder,
              private vs: ValidatorsService,
              private router: Router,
              private cdr: ChangeDetectorRef,
              private store: Store<AppState>,
              private userDataService: UserDataService) {
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('insuadvisor_token') === null || sessionStorage.getItem('insuadvisor_token') === 'undefined') {
      this.router.navigate(['login']).then();
    } else {
      this.initForm();
    }
  }

  ngAfterViewInit(): void {
    this.captchaIsLoaded = true;
    this.cdr.detectChanges();
    this.highlight();
  }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.cdr.detectChanges();
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.cdr.detectChanges();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.cdr.detectChanges();
  }

  handleReady(): void {
    this.captchaIsReady = true;
    this.cdr.detectChanges();
  }

  highlight(): void {
    const highlightBlocks = document.getElementsByTagName('code');
    for (let i = 0; i < highlightBlocks.length; i++) {
      const block = highlightBlocks[i];
      hljs.highlightBlock(block);
    }
  }

  get form() {
    return this.userDataForm.controls;
  }

  isFieldValid(field: string, $event: any) {
    this.showFieldErrorFeedback(field, $event);
    return this.userDataForm.controls[field].errors && this.userDataForm.controls[field].touched;
  }

  showFieldErrorFeedback(field: string, $event: any) {
    let msg = '';
    if ($event.errors) {
      if ($event.errors['required']) {
        msg = 'required';
        return msg;
      } else if ($event.errors['pattern']) {
        msg = 'pattern';
        return msg;
      }  else if ($event.errors['type']) {
        msg = 'type';
        return msg;
      } else {
        msg = 'size';
        return msg;
      }
    } else {
      return;
    }
  }

  initForm() {
    this.userData = this.userDataService.loadData();
    this.userDataForm = this.formBuilder.group({
      name: [this.userData.name, [Validators.required, Validators.pattern(this.vs.onlyLetters)]],
      lastname1: [this.userData.lastname1, [Validators.required, Validators.pattern(this.vs.onlyLetters)]],
      lastname2: [this.userData.lastname2, Validators.pattern(this.vs.onlyLetters)],
      email: [this.userData.email, [Validators.required, Validators.pattern(this.vs.emailPattern)]],
      phone1: [this.userData.phone1, [Validators.required, Validators.minLength(9), Validators.maxLength(15), Validators.pattern(this.vs.mobilePhonePattern)]],
      phone2: [this.userData.phone2, [Validators.minLength(9), Validators.maxLength(15), Validators.pattern(this.vs.phonePattern)]],
      currentCompany: [this.userData.currentCompany, [Validators.required, Validators.minLength(3)]],
      coverage: [this.userData.coverage, [Validators.required]],
      specSheet: ['', Validators.required],
      driverIdentification: ['', Validators.required],
      license: ['', Validators.required],
      checkPrivacy: [this.userData.checkPrivacy, Validators.requiredTrue],
      checkCalling: [this.userData.checkCalling, Validators.requiredTrue],
      recaptcha: ['', Validators.required]
    });
    this.setFilesFromStore();
  }

  setFilesFromStore() {
    this.getFileInfoFromStore(this.userData.specSheet, 'ficha_tecnica');
    this.getFileInfoFromStore(this.userData.license, 'permiso_circulacion');
    this.getFileInfoFromStore(this.userData.driverIdentification, 'documento_identidad');
  }

  getFileInfoFromStore(base64: string, fileName: string) {
    if (base64 !== '') {
      const extension = this.getFileInfo(base64)[1];
      switch (fileName) {
        case 'ficha_tecnica':
          this.specSheetFileName = 'ficha_tecnica' + extension;
          this.showSpecSheetPreview = true;
          this.specSheetBase64File = base64;
          break;
        case 'permiso_circulacion':
          this.driverIdentificationFileName = 'permiso_circulacion' + extension;
          this.showDriverIdentificationPreview = true;
          this.driverIdentificationBase64File = base64;
          break;
        case 'documento_identidad':
          this.licenseFileName = 'documento_identidad' + extension;
          this.showLicensePreview = true;
          this.licenseBase64File = base64;
          break;
      }
    }
  }

  onFileSelected($event: any, field: string) {
    const target = $event.target as HTMLInputElement;
    target.classList.add('file-selected');
    if (target.files && target.files.length > 0) {
      this.hidePreviewButton(field);
      const type = target.files[0].type;
      const size = target.files[0].size;
      if (type !== 'image/jpeg' && type !== 'image/png' && type !== 'application/pdf') {
        this.userDataForm.controls[field].setErrors({'type': true});
        target.classList.add('is-invalid');
        target.classList.remove('is-valid');
      } else if (size > 2000000) {
        this.userDataForm.controls[field].setErrors({'size': true});
        target.classList.add('is-invalid');
        target.classList.remove('is-valid');
      } else {
        this.userDataForm.controls[field].setErrors(null);
        this.saveFile(target.files[0], field);
        target.classList.add('is-valid');
        target.classList.remove('is-invalid');
      }
    }
  }

  saveFile(file: File, field: string) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    let base64 = '';
    reader.onload = () => {
      base64 = this.arrayBufferToBase64(reader.result);
      switch (field) {
        case 'specSheet':
          this.specSheetBase64File = base64;
          break;
        case 'driverIdentification':
          this.driverIdentificationBase64File = base64;
          break;
        case 'license':
          this.licenseBase64File = base64;
          break;
      }
    };
  }

  arrayBufferToBase64(buffer: any): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  hidePreviewButton(field: string) {
    switch (field) {
      case 'specSheet':
        this.showSpecSheetPreview = false;
        break;
      case 'driverIdentification':
        this.showDriverIdentificationPreview = false;
        break;
      case 'license':
        this.showLicensePreview = false;
        break;
    }
  }

  openDocument(base64:any) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: this.getFileInfo(base64)[0]});
    const url= window.URL.createObjectURL(blob);
    window.open(url);
  }

  getFileInfo(base64: any): any {
    const token = base64.charAt(0);
    switch (token) {
      case 'J':
        return ['application/pdf', '.pdf'];
      case '/':
        return ['image/jpeg', '.jpg'];
      case 'i':
        return ['image/png', '.png'];
      default:
        return ['', ''];
    }
  }

  saveFormData() {
    this.data = this.userDataForm.value;
    const userDataObject = new UserDataModel({
      name: this.data.name,
      lastname1: this.data.lastname1,
      lastname2: this.data.lastname2,
      email: this.data.email,
      phone1: this.data.phone1,
      phone2: this.data.phone2,
      currentCompany: this.data.currentCompany,
      coverage: this.data.coverage,
      specSheet: this.specSheetBase64File,
      driverIdentification: this.driverIdentificationBase64File,
      license: this.licenseBase64File,
      checkPrivacy: true,
      checkCalling: true
    });
    this.store.dispatch(new SetUserDataAction(userDataObject));
    this.userDataService.persistData(userDataObject);
    this.router.navigate(['/confirm']).then();
  }

}
